import { render, staticRenderFns } from "./SourcePieChart.vue?vue&type=template&id=68d9fa7e&scoped=true"
import script from "./SourcePieChart.vue?vue&type=script&lang=ts"
export * from "./SourcePieChart.vue?vue&type=script&lang=ts"
import style0 from "./SourcePieChart.vue?vue&type=style&index=0&id=68d9fa7e&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68d9fa7e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/sahil-meshram/Documents/Eiosys/BFP-Admin/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('68d9fa7e')) {
      api.createRecord('68d9fa7e', component.options)
    } else {
      api.reload('68d9fa7e', component.options)
    }
    module.hot.accept("./SourcePieChart.vue?vue&type=template&id=68d9fa7e&scoped=true", function () {
      api.rerender('68d9fa7e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/dashboard/admin/components/SourcePieChart.vue"
export default component.exports